module.exports = __webpack_public_path__ + "static/media/sample_intro_2.4a09072f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/home/sample_intro_2.jpg
// module id = 1028
// module chunks = 0